export function isSegmentValidForAutomation(segment) {
  const SegmentRulesInvalidForAutomations = [
    'be days after',
    'be days before',
    'be more days after',
    'be more days before',
    'be less days after',
    'be less days before'
  ]
  const arr = Array.isArray(segment.queryObj)
    ? segment.queryObj
    : (segment.queryObj.and || []).concat(segment.queryObj.or || [])
  if (arr.some((a) => SegmentRulesInvalidForAutomations.indexOf(a.operator) > -1)) {
    return false
  }
  return true
}
